import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import { useEffect, useMemo, useRef } from 'react';
import Map, { GeolocateControl, Marker, NavigationControl } from 'react-map-gl/mapbox';
import { useGetClientsLocationListQuery } from '../../../../application/features/clients/client-api';
import { useAppSelector } from '../../../../application/store/useStore';
var ClientsMap = function (_a) {
    var onMarkerClick = _a.onMarkerClick, filterClients = _a.filterClients, filterLocations = _a.filterLocations, setClientsCount = _a.setClientsCount;
    var mapboxAccessToken = useAppSelector(function (state) { return state.auth; }).mapboxAccessToken;
    var geoControlRef = useRef(null);
    var _b = useGetClientsLocationListQuery({
        clients: filterClients,
        locations: filterLocations
    }).data, clients = _b === void 0 ? [] : _b;
    useEffect(function () {
        navigator.geolocation.getCurrentPosition(function () {
            setTimeout(function () {
                var _a;
                (_a = geoControlRef.current) === null || _a === void 0 ? void 0 : _a.trigger();
            }, 500);
        });
    }, []);
    useEffect(function () {
        setClientsCount(clients.length);
    }, [clients, setClientsCount]);
    var pins = useMemo(function () {
        return clients.flatMap(function (client) { return (_jsx(Marker, { longitude: client.longitude, latitude: client.latitude, anchor: 'bottom', onClick: function (e) {
                e.originalEvent.stopPropagation();
                onMarkerClick(client.id);
            }, children: _jsx(Icon, { icon: 'solar:map-point-bold', color: 'red', fontSize: 30, cursor: 'pointer' }) }, client.id)); });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clients]);
    return (_jsx(Box, { sx: { width: '100%', height: '60vh', overflow: 'hidden' }, children: _jsxs(Map, { style: { width: '100%', height: '100%' }, reuseMaps: true, attributionControl: false, mapStyle: 'mapbox://styles/mapbox/streets-v12', mapboxAccessToken: mapboxAccessToken, children: [_jsx(NavigationControl, {}), _jsx(GeolocateControl, { positionOptions: { enableHighAccuracy: true }, trackUserLocation: true, showUserLocation: true, showAccuracyCircle: false, ref: geoControlRef }), pins] }) }));
};
export default ClientsMap;
